import axios from "axios";
import React from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

const InventoryTable = ({
  products,
  handleDuplicateProduct,
  handleDeleteProduct,
  handleProductMutation,
  fetchProducts,
  currentPage,
  totalPages,
  onNext,
  onPrevious,
}) => {
 const handleDelete = async (productId) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "This action cannot be undone.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete it!",
    customClass: {
      title: "swal-text-black",
      popup: "swal-text-black",
      confirmButton: "swal-text-black",
      cancelButton: "swal-text-black",
    },
  });

  if (!result.isConfirmed) return;

  try {
    await axios.delete(
      `https://server-gs.vercel.app/deleteProduct/${productId}`
    );
    handleDeleteProduct(productId);

    Swal.fire({
      title: "Deleted!",
      text: "Product deleted successfully.",
      icon: "success",
      customClass: {
        title: "swal-text-black",
        popup: "swal-text-black"
      }
    });
  } catch {
    Swal.fire({
      title: "Error",
      text: "Failed to delete the product.",
      icon: "error",
      customClass: {
        title: "swal-text-black",
        popup: "swal-text-black"
      }
    });
  }
};


  const handleDuplicate = async (productId) => {
  const result = await Swal.fire({
    title: "Duplicate Inventory?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes, duplicate it!",
    customClass: {
      title: "swal-text-black",
      popup: "swal-text-black",
      confirmButton: "swal-text-black",
      cancelButton: "swal-text-black",
    },
  });

  if (!result.isConfirmed) return;

  try {
    const res = await axios.post(
      "https://server-gs.vercel.app/duplicate-inventory",
      { productId }
    );

    const duplicatedProduct = res.data.duplicatedProduct;
    handleDuplicateProduct(duplicatedProduct);

    Swal.fire({
      title: "Duplicated!",
      text: "Product duplicated successfully.",
      icon: "success",
      customClass: {
        title: "swal-text-black",
        popup: "swal-text-black"
      }
    });
  } catch {
    Swal.fire({
      title: "Error",
      text: "Failed to duplicate the product.",
      icon: "error",
      customClass: {
        title: "swal-text-black",
        popup: "swal-text-black"
      }
    });
  }
};


  return (
    <div className="flex-1 overflow-x-auto h-[calc(100vh-80px)] bg-white">
  <table className="w-full text-sm text-left border-separate border-spacing-0">
    <thead className="sticky top-0 z-20">
      <tr className="bg-gray-50 border-b border-gray-200">
        <th className="px-6 py-4 font-semibold text-gray-600 border-b">Product Info</th>
        <th className="px-6 py-4 font-semibold text-gray-600 border-b">Code</th>
        <th className="px-6 py-4 font-semibold text-gray-600 border-b">Type</th>
        <th className="px-6 py-4 font-semibold text-gray-600 border-b">Category</th>
        <th className="px-6 py-4 font-semibold text-gray-600 border-b text-center">Stock</th>
        <th className="px-6 py-4 font-semibold text-gray-600 border-b">Price</th>
        <th className="px-6 py-4 font-semibold text-gray-600 border-b text-center">Actions</th>
      </tr>
    </thead>
    <tbody className="divide-y divide-gray-100">
      {products.map((p, index) => (
        <tr key={p._id} className="group hover:bg-blue-50/40 transition-colors">
          <td className="px-6 py-4">
            <Link to={`/dashboard/inventory-details/${p._id}`} className="flex items-center gap-4">
              <div className="relative h-14 w-14 flex-shrink-0">
                <img
                  className="h-full w-full rounded-lg object-cover border border-gray-200 shadow-sm"
                  src={p.singleImage}
                  alt={p.title}
                />
              </div>
              <div className="max-w-[200px]">
                <h3 className="font-bold text-gray-900 group-hover:text-blue-600 truncate transition-colors">
                 {index + 1} {p.title}
                </h3>
                <span className="text-xs text-gray-400 font-roboto">Added: {new Date(p.createdAt).toLocaleDateString()}</span>
              </div>
            </Link>
          </td>
          <td className="px-6 py-4 font-mono text-xs font-semibold text-gray-500 uppercase">{p.productCode}</td>
          <td className="px-6 py-4">
            <span className={`px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider ${p.type === 'package' ? 'bg-purple-100 text-purple-700' : 'bg-emerald-100 text-emerald-700'}`}>
              {p.type}
            </span>
          </td>
          <td className="px-6 py-4 text-gray-600 text-xs italic">
            {p.categoryTitle}
          </td>
          <td className="px-6 py-4 text-center">
            <div className={`inline-block px-2 py-1 rounded text-xs font-bold ${p.quantity < 5 ? 'text-red-600 bg-red-50' : 'text-gray-700'}`}>
              {p.quantity}
            </div>
          </td>
          <td className="px-6 py-4 font-bold text-gray-900">
            ${p.perDayPricing}
          </td>
          <td className="px-6 py-4">
            <div className="flex items-center justify-center gap-3">
              <button
                onClick={() => handleDuplicate(p._id)}
                className="p-1.5 text-gray-400 hover:text-green-600 hover:bg-green-50 rounded-md transition-all"
                title="Duplicate"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2" />
                </svg>
              </button>
              <button
                onClick={() => handleDelete(p._id)}
                className="p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-md transition-all"
                title="Delete"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            </div>
          </td>
        </tr>
      ))}
    </tbody>
  </table>

  {/* Pagination */}
  <div className="sticky bottom-0 bg-white/80 backdrop-blur-md border-t border-gray-200 px-6 py-4 flex items-center justify-between">
    <span className="text-sm text-gray-500 font-roboto">
      Showing Page <span className="font-bold text-gray-800">{currentPage}</span> of {totalPages}
    </span>
    <div className="flex gap-2">
      <button
        onClick={onPrevious}
        disabled={currentPage === 1}
        className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
      >
        Previous
      </button>
      <button
        onClick={onNext}
        disabled={currentPage === totalPages}
        className="px-4 py-2 bg-gray-900 text-white rounded-lg text-sm font-medium hover:bg-gray-800 disabled:opacity-50 transition-all"
      >
        Next Page
      </button>
    </div>
  </div>
</div>
  );
};

export default InventoryTable;
